export class EventHelper {
  public static stopEventHere(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }
}
